import Types from '../types'

const initialState = {
    allUsers: [],
    loggedUser: null
};
export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case Types.ALL_USERS:
            return {
                ...state,
                allUsers: action.payload
            };
        case Types.LOGGED_USER:
            return {
                ...state,
                loggedUser: action.payload
            };
        default:
            return state;
    }
}
